<template>
    <div>
      <h5 class="text-left mb-3">{{ category }} List</h5>
      <table class="table table-striped">
        <thead>
          <tr><th>#</th><th>Title</th><th>Description</th><th>Date</th></tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in data" :key="item.id">
            <td>{{ i + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.description }}</td>
            <td>{{ formatDate(item.createdDate) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name: "DefaultListPopup",
    props: ["data", "category"],
    methods: {
      formatDate(dateStr) {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-MY", { year: "numeric", month: "short", day: "numeric" });
      }
    }
  };
  </script>